import { Injectable } from '@angular/core';
import { MailInsert } from '../models/iCourrier/post/mail-insert';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { Mail } from '../models/mails/mail';
import { ConfigDto } from '../interfaces/config';
import { LowInformationContact } from 'src/app/shared/models/iContact/contact/low-information-contact';
import { NatureDto } from '../interfaces';
import { ExchangeMailListColumn } from '../models/exchange/exchange';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private refreshList = new Subject<boolean>();
  public getRefreshList(): Observable<boolean> {
    return this.refreshList.asObservable();
  }
  public setRefreshList(refresh: boolean) {
    this.refreshList.next(refresh);
  }
  private refreshFileList = new Subject<number>();
  public getRefreshFileList(): Observable<number> {
    return this.refreshFileList.asObservable();
  }
  public setRefreshFileList(refresh: number) {
    this.refreshFileList.next(refresh);
  }

  private mailActive = new Subject<Mail>();
  public getMailActive: Observable<Mail> = this.mailActive.asObservable();
  public setMailActive(mail: Mail) {
    this.mailActive.next(mail);
  }

  private mailGlob = new Subject<MailInsert>();
  public getMailGlob(): Observable<MailInsert> {
    return this.mailGlob.asObservable();
  }
  public setMailGlob(value: MailInsert) {
    this.mailGlob.next(value);
  }

  private smallSidebar = new BehaviorSubject<boolean>(false);
  public hasSmallSidebar = this.smallSidebar.asObservable();
  public setSidebarSmall(value: boolean) {
    this.smallSidebar.next(false);
    this.smallSidebar.next(value);
  }

  private reloadInfo = new BehaviorSubject<boolean>(false);
  public reloadInfoBool = this.reloadInfo.asObservable();
  public setReloadToTrue(value: boolean) {
    return this.reloadInfo.next(value);
  }

  private attachementFile = new BehaviorSubject<File | null>(null);
  public attachementFileInfo = this.attachementFile.asObservable();
  public setCurrentAttachement(value: File | null) {
    return this.attachementFile.next(value);
  }

  private canLeaveEditor = new BehaviorSubject<boolean>(true);
  public canLeaveEditorInfo = this.canLeaveEditor.asObservable();
  public setCanLeaveEditor(value: boolean) {
    return this.canLeaveEditor.next(value);
  }

  private reloadContact = new BehaviorSubject<boolean>(false);
  public reloadContactBool = this.reloadContact.asObservable();
  public setReloadContact(value) {
    return this.reloadContact.next(value);
  }

  private contactslow = new BehaviorSubject<LowInformationContact[]>([]);
  public getLowContacts = this.contactslow.asObservable();
  public setAllContacts(value: LowInformationContact[]) {
    return this.contactslow.next(value);
  }

  public configApp = new BehaviorSubject<ConfigDto>(null);
  public getConfigApp = this.configApp.asObservable();
  public setConfigApp(value: ConfigDto) {
    return this.configApp.next(value);
  }

  private versionApp = new BehaviorSubject<string>(null);
  public getversiongApp = this.versionApp.asObservable();
  public setVersionApp(value: string) {
    return this.versionApp.next(value);
  }

  private currentMail = new BehaviorSubject<ExchangeMailListColumn>(null);
  public getCurrentMail = this.currentMail.asObservable();
  // Attention, on fait un setCurrentMail UNIQUEMENT quand on veut créer un nouveau courrier sur base d'un email importé a la main
  public setCurrentMail(value: ExchangeMailListColumn) {
    return this.currentMail.next(value);
  }

  public checkIfUnsavedChanges = false;

  private listOfNatures = new BehaviorSubject<NatureDto[]>(null);
  public getListOfNatures = this.listOfNatures.asObservable();
  public setListOfNatures(value: NatureDto[]) {
    return this.listOfNatures.next(value);
  }
}
